import { render } from "./affiliate-question-bundle.view.vue?vue&type=template&id=214efa6c&scoped=true&ts=true"
import script from "./affiliate-question-bundle.view.vue?vue&type=script&lang=ts"
export * from "./affiliate-question-bundle.view.vue?vue&type=script&lang=ts"

import "./affiliate-question-bundle.view.vue?vue&type=style&index=0&id=214efa6c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214efa6c"]])

export default __exports__